var $8f13b60c0ee5b277$exports = {};
$8f13b60c0ee5b277$exports = JSON.parse('{"name":"@eyevinn/www","version":"1.12.0","description":"Eyevinn main website","scripts":{"start":"parcel src/*.html --no-cache","build":"parcel build --public-url ./ src/*.html  --no-cache","postversion":"git push && git push --tags"},"author":"Eyevinn Technology <webmaster@eyevinn.se>","license":"ISC","devDependencies":{"buffer":"^6.0.3","parcel":"^2.11.0","prettier":"^2.5.1","process":"^0.11.10"},"dependencies":{"@aws-sdk/client-cognito-identity":"^3.53.0","@aws-sdk/client-sns":"^3.53.0","@aws-sdk/credential-provider-cognito-identity":"^3.53.0"}}');


var $8dc4352c8968dbc4$require$version = $8f13b60c0ee5b277$exports.version;
window.addEventListener("DOMContentLoaded", ()=>{
    let dev = "";
    dev = "-dev";
    document.querySelector("#version").innerHTML = $8dc4352c8968dbc4$require$version + dev;
});


//# sourceMappingURL=index.6714fbaf.js.map
